import { createContext, useContext } from 'react';

type HideableSectionContextState = {
  hideableSectionId: string;
};

const HideableSectionContext = createContext({
  hideableSectionId: '',
} as HideableSectionContextState);

export const useHideableSectionContext = () =>
  useContext(HideableSectionContext);

interface HideableSectionProviderProps {
  hideableSectionId: string;
  children: JSX.Element;
}

export const HideableSectionProvider = ({
  children,
  hideableSectionId,
}: HideableSectionProviderProps) => {
  const values = {
    hideableSectionId,
  };

  return (
    <HideableSectionContext.Provider value={values}>
      {children}
    </HideableSectionContext.Provider>
  );
};
